export interface BeadPalette {
  readonly top: string;
  readonly bottom: string;
  readonly edge: string;
  readonly shadow: string;
  readonly guide: string;
  readonly label: string;
}

const PALETTES: Readonly<Record<string, BeadPalette>> = {
  coral: { top: "#ff7160", bottom: "#d93631", edge: "#b82728", shadow: "#a5252b", guide: "#f05a50", label: "珊瑚红" },
  mango: { top: "#ffbd53", bottom: "#ed7c28", edge: "#c65a22", shadow: "#a94b21", guide: "#f2a047", label: "芒果橙" },
  rose: { top: "#ff8fb0", bottom: "#df4f7f", edge: "#b83c6b", shadow: "#982e5a", guide: "#ea6a91", label: "玫瑰粉" },
  sky: { top: "#72c9ff", bottom: "#3f7ee9", edge: "#2d60c9", shadow: "#274fa6", guide: "#4e8ef3", label: "晴空蓝" },
  cream: { top: "#fff9dc", bottom: "#e8d8ab", edge: "#c2ad7d", shadow: "#9f8c67", guide: "#eedfc3", label: "奶油白" },
  graphite: { top: "#6d7177", bottom: "#35383d", edge: "#25272b", shadow: "#17191d", guide: "#505359", label: "石墨黑" },
  jade: { top: "#66d6c2", bottom: "#2ca893", edge: "#218474", shadow: "#19685d", guide: "#43b9a7", label: "薄荷青" },
  violet: { top: "#c493ff", bottom: "#7c5cdd", edge: "#6146b9", shadow: "#4e3897", guide: "#8b6bdf", label: "葡萄紫" },
};

const FALLBACK: BeadPalette = {
  top: "#f6d75a",
  bottom: "#e59b2c",
  edge: "#c27321",
  shadow: "#9d591d",
  guide: "#dba33c",
  label: "拼豆",
};

export function beadPalette(color: string): BeadPalette {
  return PALETTES[color] ?? FALLBACK;
}

export function beadCss(color: string): string {
  const palette = beadPalette(color);
  return `--bead-top:${palette.top};--bead-bottom:${palette.bottom};--bead-edge:${palette.edge};--bead-shadow:${palette.shadow}`;
}
